import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const SearchContainer = styled.div`
  position: relative;
  height: 32px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  padding: 4px;
  justify-content: space-between;
`;
export const SearchInput = styled.input`
  width: ${props => props.width || '200px'};
  height: ${props => props.height || '24px'};
  padding-left: 25px;
  padding-right: 8px;
  border: ${props => props.borderColor || 'none'};
  border-radius: 4px;
  background-color: ${props => props.bgColor || `${ColorSF2.lightGray}`};
`;
export const SearchImage = styled.img`
  position: absolute;
  height: 18px;
  left: 10px;
`;
